module.exports = __webpack_public_path__ + "img/demo-person.5247b591.png";